Object.defineProperty(exports,"__esModule",{value:true});exports.


















friendlyDeviceType=friendlyDeviceType;var DeviceType=exports.DeviceType={BASE:'base',PUCK:'puck',LOCK:'lock',ALARM_MODULE:'alarm_module',DUMB_PUCK:'dumb_puck',RAM:'ram',SECURE_PLUG:'secure_plug',CX_FLEX:'core_iii',CX_FLEX_ONE_PORT:'core_iii_one_port',CX_FLEX_FOUR_PORT:'core_iii_four_port',BASE_V2:'base_v2',PUCK_V2:'puck_v2',PROXIMITY_BASE:'proximity_base',PROXIMITY_PUCK:'proximity_puck',NXDI_PUCK:'di_puck',NXDI_RISER:'di_riser'};function friendlyDeviceType(deviceType){
switch(deviceType){
case DeviceType.BASE:
return'Base';
case DeviceType.PUCK:
return'Puck';
case DeviceType.LOCK:
return'Lock';
case DeviceType.ALARM_MODULE:
return'Alarm Module';
case DeviceType.DUMB_PUCK:
return'Puck';
case DeviceType.RAM:
return'RAM';
case DeviceType.SECURE_PLUG:
return'Secure Plug';
case DeviceType.CX_FLEX:
return'CX Flex 1 Port';
case DeviceType.CX_FLEX_ONE_PORT:
return'CX Flex 1 Port';
case DeviceType.CX_FLEX_FOUR_PORT:
return'CX Flex 4 Port';
case DeviceType.BASE_V2:
return'FM II Base';
case DeviceType.PUCK_V2:
return'FM II Puck';
case DeviceType.PROXIMITY_PUCK:
return'Proximity Puck';
case DeviceType.PROXIMITY_BASE:
return'Proximity Base';
case DeviceType.NXDI_PUCK:
return'Freedom Focus Puck';
case DeviceType.NXDI_RISER:
return'Freedom Focus Riser';
default:
return deviceType;}

}

var resourceType=exports.resourceType={
SECURITY_DEVICE:'security_device',
POSITION:'position',
FIXTURE:'fixture',
FLOOR:'floor',
AREA:'area',
SECURED_PRODUCT:'secured_product'};


var armState=exports.armState={
ALARMING:'alarming',
SILENT_ALARMING:'silent_alarming',
ARMED:'armed',
DISARMED:'disarmed',
LOCKED:'locked',
UNLOCKED:'unlocked',
OPEN:'open',
OTHER_STATE:'otherState',
PARTIALLY_ARMED:'partiallyArmed',
PARTIALLY_LOCKED:'partiallyLocked',
FIXTURE_EMPTY:'fixtureEmpty',
MISSING_SECURITY_DEVICE:'missingSecurityDevice',
UNKNOWN_DEVICE:'unknownDevice'};


var powerState=exports.powerState={
POWERED:'powered',
UNPOWERED:'unpowered'};




var positionAction=exports.positionAction={
IDENTIFY:'identify',
ARM:'arm',
DISARM:'disarm',
SILENCE:'silence',
POWER:'power',
UNPOWER:'unpower',
LATCH:'latch',
UNLATCH:'unlatch'};